var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap -mb-4"},_vm._l((_vm.data),function(value,prop){return _c('div',{key:prop,staticClass:"w-full md:w-36 md:mr-4 mb-4"},[_c('div',{staticClass:"bg-gray-400 dark:bg-gray-700 mb-2 md:w-36 h-36",style:({
        borderRadius: value
      })}),_c('CanvasBlockLabel',{attrs:{"label":("" + (_vm.removeDefaultSuffix(("rounded-" + prop)))),"value":value}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }